import User from '@/models/User'

const state = {
    managers: undefined,
}

const getters = {
    managers: state => state.managers,
}

const actions = {
    async initManagers({ getters, commit }) {
        if (!getters.managers === undefined) return

        let perPage = 50
        let page = 1
        let lastPage = 1
        let managers = []

        for (page; page <= lastPage; page++) {
            let res = await new User()
                .where('accountManagers', true)
                .paginate(perPage, page)

            lastPage = res.meta.pagination.total_pages
            managers = managers.concat(res.data)
        }

        commit('setManagers', managers)
    },
}

const mutations = {
    setManagers(state, managers) {
        state.managers = managers
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
